import type { StaffDirectoryEntry } from '@tradeoutlet/shared';

export type BulkSource =
  | { type: 'team'; id: string }
  | { type: 'location'; id: string }
  | { type: 'position'; id: string };

/** Everyone in a team, building or position, from the staff list (active members only). */
export function expandSource(staff: StaffDirectoryEntry[], src: BulkSource): string[] {
  return staff.filter(s => (src.type === 'team' ? s.team_ids : src.type === 'location' ? s.location_ids : s.position_ids).includes(src.id)).map(s => s.user_id);
}

/** Add ids in order without duplicates; returns the new list and how many were new. */
export function mergeMembers(current: string[], ids: string[], exclude?: string | null): { members: string[]; added: number } {
  const seen = new Set(current);
  const out = [...current];
  for (const id of ids) if (id !== exclude && !seen.has(id)) { seen.add(id); out.push(id); }
  return { members: out, added: out.length - current.length };
}

/** "Room · Sun 18 Oct" in the user's zone. */
export function defaultRoomName(now = new Date(), timeZone = 'Europe/London'): string {
  const f = new Intl.DateTimeFormat('en-GB', { timeZone, weekday: 'short', day: 'numeric', month: 'short' }).formatToParts(now);
  const get = (t: string) => f.find(p => p.type === t)?.value ?? '';
  return `Ad-hoc meeting room · ${get('weekday')} ${get('day')} ${get('month')}`;
}
